import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { apiUrlComponent } from '../common/api.url.component';
import { ApiService } from '../common/API/api.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import * as $ from 'jquery';
import {MatPaginator, MatTableDataSource} from '@angular/material';
declare var config;
import {BackRestrict} from '../common/backRestrict'
@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {
  @ViewChild('userpassword') userpassword: ElementRef;
  @ViewChild('enterprise') enterprise: ElementRef;
  @ViewChild('enterprisePartner') enterprisePartner: ElementRef;
  @ViewChild('store') store: ElementRef;
  @ViewChild('txtbox') txtbox: ElementRef;
 

  public dataSource :  MatTableDataSource<UserInfo>;
  public Users:  UserInfo[]= [];
  public submitted: boolean = false;
  public invalidEmail: boolean;
  public EnterpriseList: any;
  public EnterprisePartnerList: any;
  public StoreList: any;
  public UserDepartmentList: any;
  public UserTypeList: any;
  public UserRoleList: any;
  public modfyEnterprisePartnerList: any;
  public modfyStoreList: any;
  public modfyDepartmentList: any;
  public modfyUserTypeList: any;
  public modfyUserRoleList: any;
  form: FormGroup;
  responseResult = '';
  public Cond_User: any;

  private readonly notifier: NotifierService;
  is_disable: boolean;
  dropdownlist: boolean;
  emptyEmail: boolean;
  DisableSubmitButton: boolean;
  constructor(private _apiService: ApiService,private backrestrict:BackRestrict,
    private renderer: Renderer2,
    private formbuilder: FormBuilder, private apiUrl: apiUrlComponent, notifierService: NotifierService) {
    this.form = formbuilder.group({
      FirstName: ['', Validators.required],
      MiddleName: [],
      LastName: ['', Validators.required],
      Email: [''],// Validators.compose([Validators.required]), Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$')
      ContactNo: ['', Validators.compose([Validators.required, Validators.minLength(10), Validators.maxLength(12)])],
      Enterprise: ['', Validators.required],
      EnterprisePartner: ['', Validators.required],
      Store: ['', Validators.required],
      // Password:['',Validators.required],
      UserName: ['', Validators.required],
      UserDepartment: ['', Validators.required],
      UserType: ['', Validators.required],
      UserRole: ['', Validators.required]
    });
    this.notifier = notifierService;
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;
  public pageSizeOptions=[5,10,15,20];
  public pageSize=10;
  public length=10;
  public displayedColumns  = ['UserID','User','UserName','Password','BaseEnterprise','Enterprise','Store','Action','IsActive'];
  
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }


  ngOnInit() {
    this.backrestrict.clearBrowserBackHistory();
    this.GetUser();
  }
  GetUser() {
    debugger;
    this._apiService.get(config.urlpath + 'api/getuser').subscribe(result => {
      debugger;
      if (result.Success === true) {
        this.Users          = result.Data[0];
        this.dataSource = new MatTableDataSource(this.Users);
        this.dataSource.paginator = this.paginator;
        this.EnterpriseList = result.Data[1].filter(x=>x.Enterprise!=='Corporate');;
        this.EnterprisePartnerList = result.Data[2];
        this.StoreList = result.Data[3];
        this.UserDepartmentList = result.Data[4];
        this.UserTypeList = result.Data[5];
        this.UserRoleList = result.Data[6];
      }
      else {
      }
    },
      error => {
        console.log(error);
      }
    );
  }
  onChangeEnterprise(event) {
    debugger;
    var EnterpriseID = event
    this.modfyEnterprisePartnerList = this.EnterprisePartnerList.filter((item) => item.EnterpriseID == EnterpriseID);
    this.modfyStoreList = null;
    this.form.controls['EnterprisePartner'].setValue('0');
    this.form.controls['Store'].setValue('0');
  }
  onChangeEnterprisePartner(event) {
    debugger;
    var EnterprisePartnerID = event
    this.modfyStoreList = this.StoreList.filter((item) => item.EnterprisePartnerID == EnterprisePartnerID);
    this.store.nativeElement.value = "0";
  }
  onChangeStore(event) {
    this.renderer.setStyle(this.txtbox.nativeElement, 'visibility', 'visible');
  }
  AddUser() {
    debugger;
    var Addbody = {
      UserID: null,
      StoreID: this.form.value.Store,
      FirstName: this.form.value.FirstName,
      MiddleName: this.form.value.MiddleName,
      LastName: this.form.value.LastName,
      Email: this.form.value.Email,
      ContactNo: this.form.value.ContactNo,
      UserName: this.form.value.UserName,
      // UserDepartment: this.form.value.UserDepartment,
      // UserType: this.form.value.UserType,
      // UserRole: this.form.value.UserRole,
    }
    this._apiService.post(config.urlpath + 'api/adduser', Addbody).subscribe(result => {
      if (result.Success === true) {
        debugger;
        $('#ModalClsbtn').click();
        this.notifier.notify('success', 'User Added Successfully');
        // setTimeout(
        //   function () {
        //     location.reload(true);
        //   }, 2000);
        this.GetUser();
      } else {
        this.notifier.notify('error', 'An Error Occured');
      }
    },
      error => {
        console.log(error);
      }
    );
  }
  editUser(item: any) {
    debugger;
    this.Cond_User = item;
    this.renderer.setStyle(this.txtbox.nativeElement, 'visibility', 'visible');
    this.form.controls.Enterprise.patchValue(item.EnterpriseID);
    this.modfyEnterprisePartnerList = this.EnterprisePartnerList.filter((items) => items.EnterpriseID == item.EnterpriseID);
    this.form.controls.EnterprisePartner.patchValue(item.EnterprisePartnerID);
    this.modfyStoreList = this.StoreList.filter((items) => items.EnterprisePartnerID == item.EnterprisePartnerID);
    this.form.controls.Store.patchValue(item.StoreID);
    // this.modfyDepartmentList = this.UserDepartmentList.filter((items) => items.UserDepartmentID == item.UserDepartmentID);
    // this.form.controls.UserDepartment.patchValue(item.UserDepartmentID);
    // this.modfyUserTypeList = this.UserTypeList.filter((items) => items.UserTypeID == item.UserTypeID);
    // this.form.controls.UserType.patchValue(item.UserTypeID);
    // this.modfyUserRoleList = this.UserRoleList.filter((items) => items.UserRoleID == item.UserRoleID);
    this.form.controls.UserRole.patchValue(item.UserRoleID);
    this.form.controls.FirstName.patchValue(item.FirstName);
    this.form.controls.MiddleName.patchValue(item.MiddleName);
    this.form.controls.LastName.patchValue(item.LastName);
    this.form.controls.Email.patchValue(item.EmailAddress);
    this.form.controls.UserName.patchValue(item.UserName);
    this.form.controls.ContactNo.patchValue(item.ContactNumber);
  }

  UpdateStore(userid) {
    debugger
    var UpdateBody = {
      UserID: userid,
      StoreID: this.form.value.Store,
      FirstName: this.form.value.FirstName,
      MiddleName: this.form.value.MiddleName,
      LastName: this.form.value.LastName,
      Email: this.form.value.Email,
      ContactNo: this.form.value.ContactNo,
      UserName: this.form.value.UserName,
      // UserDepartment: this.form.value.UserDepartment,
      // UserType: this.form.value.UserType,
      // UserRole: this.form.value.UserRole,
    };
    this._apiService.post(config.urlpath + 'api/adduser', UpdateBody).subscribe(result => {
      if (result.Success === true) {
        debugger;
        $('#ModalClsbtn').click();
        this.notifier.notify('success', 'User Updated Successfully');
        // setTimeout(
        //   function () {
        //     location.reload(true);
        //   }, 2000);
        this.GetUser();
      } else {
        this.notifier.notify('error', 'An Error Occured');
      }
    },
      error => {
        console.log(error);
      }
    );

  }

  onChange(event, item: any) {
    debugger;
    var IsActiveBody = {
      UserID: item,
      IsActive: event
    };
    this._apiService.post(config.urlpath + 'api/adduser', IsActiveBody).subscribe(result => {
      debugger;
      if (event) {
        this.notifier.notify('success', 'User Activated Successfully');
      }
      else {
        this.notifier.notify('warning', 'User Deactivated Successfully');
      }
    })
  }

  emptyform() {
    debugger;
    this.invalidEmail = false;
    this.emptyEmail = false;
    this.form.reset();
    this.Cond_User = undefined;
    this.renderer.setStyle(this.txtbox.nativeElement, 'visibility', 'hidden');
    this.modfyEnterprisePartnerList = null;
    this.modfyStoreList = null;
    this.form.controls['Enterprise'].setValue('0');
    this.form.controls['EnterprisePartner'].setValue('0');
    this.form.controls['Store'].setValue('0');
    this.form.controls['UserDepartment'].setValue('0');
    this.form.controls['UserType'].setValue('0');
    this.form.controls['UserRole'].setValue('0');
  }

  keyPressNumber(event: any) {
    debugger;
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  keyPressName(event: any) {
    debugger;
    const pattern = /^[a-zA-Z ]*$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  onBlurMethod(val: any) {
    if (val !== '') {
      this.emptyEmail = false;
      const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
      if (!pattern.test(val)) {
        this.invalidEmail = true;
        this.DisableSubmitButton=true;
      }
      else {
        this.invalidEmail = false;
        this.DisableSubmitButton=false;
      }
    }
    else {

      this.invalidEmail = false;
      this.emptyEmail = true;
    }
  }
  keyPressEmail() {
    this.invalidEmail = false;
    this.emptyEmail = false;
  }
}
export interface UserInfo {
  UserID: number;
  FirstName: string;
  MiddleName: string ;
  LastName: string;
  UserName: string;
  Enterprise: string;
  EnterprisePartner: string ;
  Store: string;
}
